interface Props {
  onEnter: () => void;
}

export function LightPortal({ onEnter }: Props) {
  return (
    <section id="light-portal" className="light-portal" aria-labelledby="light-title">
      <img src="/assets/avi-rivka-light.jpeg" alt="אבי ורבקה מביטים יחד אל מקור אור" />
      <div className="light-edge" aria-hidden="true" />
      <div className="light-copy">
        <h2 id="light-title">יש אור שמחכה רק לך</h2>
        <button className="light-button" onClick={onEnter}>
          <span className="light-orb" aria-hidden="true" />
          לחצי על האור
        </button>
      </div>
    </section>
  );
}
